jQuery(function () {
	var vid = document.getElementById("video-mob");
	jQuery(".video-btn").click(function () {
		vid.play();
	});
	jQuery(".side-bar-title").click(function () {
		jQuery(".side-bar").toggleClass("active-side");
	});
	jQuery(".delete-account-btn").click(function () {
		jQuery(".delete-account-main").removeClass("d-none");
	});
	jQuery(".delete-account-modal-cancel-btn").click(function () {
		jQuery(".delete-account-main").addClass("d-none");
	});
	jQuery(".delete-account-modal-close-btn").click(function () {
		jQuery(".delete-account-main").addClass("d-none");
	});
	jQuery(".cross").click(function () {
		jQuery(".delete-account-main").removeClass("delete-active");
	});
	jQuery(".mobile-nav-btn").click(function () {
		jQuery(".header-menu ul").toggleClass("active-header-ul");
		jQuery(".header-menu").toggleClass("active-header");
	});
	jQuery(".filter-mobile-lable").click(function () {
		jQuery(".filter-radiobtn-mobile-btn").toggleClass("filter-radiobtn-mobile-active");
		jQuery(".filter-mobile-lable").toggleClass("lable-active");
	});

	// check if btn exists
	if (jQuery('#btn').length > 0) {
		document.getElementById('btn').addEventListener('click', () => {
			document.getElementById('inputField').click();
		});
	}

	// if #vacancy_view input is clicked, redirect to vacancy page
	jQuery('#vacancy_view').on('click', function () {
		window.location.href = jQuery(this).attr('data-redirecturl');
	});


	jQuery('.vacancy-file-upload-field').on('change', function () {
		var fileList = jQuery('#vacancy-fileList');

		if (!fileList.hasClass('editing-vacancy')) {
			fileList.html(''); // Clear current file list
		}
		jQuery.each(this.files, function (i, file) {
			fileList.append('<p>' + file.name + '</p>'); // Add new file name
		});
		if (this.files.length > 0) {
			fileList.show().hide().slideDown(500); // Show and animate the fileList only if files are added
		} else {
			fileList.hide(); // If no files are added, keep it hidden
		}
	});

})


jQuery(document).on('change', 'select[name="epm_topic"]', function () {
	window.location.href = jQuery(this).find('option:selected').attr('data-redirecturl');
});

jQuery(document).ready(function ($) {
	$('.guidance-anchor-link-wrap-mobile select#anchor-links').on('change', function () {
		var selected = $(this).find('option:selected').val();
		if (selected) {
			$('html, body').animate({
				scrollTop: $("#" + selected).offset().top - 100
			}, 1000);
		}
	});


	// get url of current page
	// check if #topic-form exists
	if ($('#topic-form').length > 0) {
		var currentUrl = window.location.href;
		// compare current url to url of each option in select .filter-select of data-redirecturl
		$('#topic-form .filter-select option').each(function () {
			var optionUrl = $(this).attr('data-redirecturl');
			if (currentUrl == optionUrl) {
				$(this).attr('selected', 'selected');
				$(".filter-select-lable-topics").text("Change Topic");
			}

		});
	}

	// for .EPM-guides-main.checklist .featured-download-card h6 check if text is longer than 35 characters and cut it off with ... if it is
	$('.EPM-guides-main.checklist .featured-download-card h6').each(function () {
		var text = $(this).text();
		if (text.length > 35) {
			$(this).text(text.substring(0, 40) + '...');
		}
	});


	// Audio Video Modal Code

	// Get the modal
	var modal = $('#video-audio-modal');

	// Get the <span> element that closes the modal
	var span = $('.close');

	$('.featured-card-play-button a').click(function (e) {
		e.preventDefault();
		var link = $(this).data('video-audio-link');

		// Hide both players initially
		$('#video-audio-modal .video-container').hide();
		$('#video-audio-modal .audio-container').hide();

		if (link.endsWith('.mp4')) {
			// Show video player and set source
			$('#video-audio-modal .video-container').show();
			$('#video-audio-modal #video-source').attr('src', link);
			$('#video-audio-modal #video-player')[0].load();  // need to load the new source
		} else if (link.endsWith('.mp3')) {
			// Show audio player and set source
			$('#video-audio-modal .audio-container').show();
			$('#video-audio-modal #audio-source').attr('src', link);
			$('#video-audio-modal #audio-player')[0].load();  // need to load the new source
		}

		// When the user clicks the button, open the modal 
		modal.css('display', 'block');
	});

	// When the user clicks on <span> (x), close the modal
	span.click(function () {
		modal.css('display', 'none');
		// Pause and reset media when modal is closed
		$('#video-audio-modal #video-player')[0].pause();
		$('#video-audio-modal #video-player')[0].currentTime = 0;
		$('#video-audio-modal #audio-player')[0].pause();
		$('#video-audio-modal #audio-player')[0].currentTime = 0;
	});

	// When the user clicks anywhere outside of the modal, close it
	$(window).click(function (event) {
		if ($(event.target).is(modal)) {
			modal.css('display', 'none');
			// Pause and reset media when modal is closed
			$('#video-audio-modal #video-player')[0].pause();
			$('#video-audio-modal #video-player')[0].currentTime = 0;
			$('#video-audio-modal #audio-player')[0].pause();
			$('#video-audio-modal #audio-player')[0].currentTime = 0;
		}
	});


});



function checkIfNoArticles() {
	jQuery(".featured-articles").each(function () {
		var total = jQuery(this).find(".dif-featured-card").length;
		var hidden = jQuery(this).find(".dif-featured-card.d-none").length;
		if (total == hidden) {
			jQuery(this).find(".articles-nothing-found").removeClass("d-none");
		} else {
			jQuery(this).find(".articles-nothing-found").addClass("d-none");
		}
		console.log("total: " + total + " hidden: " + hidden);
	});
}

function checkIfNoDownloads() {
	jQuery(".featured-downloads").each(function () {
		var total = jQuery(this).find(".featured-download-card").length;
		var hidden = jQuery(this).find(".featured-download-card.d-none").length;
		if (total == hidden) {
			jQuery(this).find(".downloads-nothing-found").removeClass("d-none");
		} else {
			jQuery(this).find(".downloads-nothing-found").addClass("d-none");
		}
		console.log("total: " + total + " hidden: " + hidden);
	});
}

function checkIfNoTopics() {
	jQuery(".topic-areas-article").each(function () {
		var total = jQuery(this).find(".topic-areas-card").length;
		var hidden = jQuery(this).find(".topic-areas-card.d-none").length;
		if (total == hidden) {
			jQuery(this).find(".topics-nothing-found").removeClass("d-none");
		} else {
			jQuery(this).find(".topics-nothing-found").addClass("d-none");
		}
		console.log("total: " + total + " hidden: " + hidden);
	});
}




jQuery(function () {

	function checkCardNumbers(selectors) {
		for (let i = 0; i < selectors.length; i++) {
			jQuery(selectors[i]).each(function () {
				let cardWrap = jQuery(this);
				let cards = cardWrap.find('.dif-featured-card:not(.d-none), .topic-areas-card:not(.d-none), .featured-download-card:not(.d-none)');

				if (cards.length == 1) {
					cardWrap.addClass('one-card-wrap');
				} else {
					cardWrap.removeClass('one-card-wrap');
				}
			});
		}
	}

	checkCardNumbers(['.featured-card-main', '.topic-areas-main', '.download-card-main']);


	jQuery('.filter-radiobtn').on('change', function () {
		var filter = jQuery('.filter-radiobtn[name="guidanceFilter"]:checked').val();
		if (filter === "all") {
			jQuery('.dif-featured-card').removeClass('d-none');
			jQuery('.topic-areas-card').removeClass('d-none');
			jQuery('.featured-download-card').removeClass('d-none');
		} else {
			jQuery('.dif-featured-card').addClass('d-none');
			jQuery('.dif-featured-card').each(function (k, v) {
				var cat_string = jQuery(v).find('.card-service-area p').text();

				if (cat_string.includes(filter)) {
					jQuery(v).removeClass('d-none');
				}
			});

			jQuery('.featured-download-card').addClass('d-none');
			jQuery('.featured-download-card').each(function (k, v) {
				var cat_string = jQuery(v).find('.download-card-upper-content p').text();

				if (cat_string.includes(filter)) {
					jQuery(v).removeClass('d-none');
				}
			});

			jQuery('.topic-areas-card').addClass('d-none');
			jQuery('.topic-areas-card').each(function (k, v) {
				var cat_string = jQuery(v).find('.card-service-area p').text();

				if (cat_string.includes(filter)) {
					jQuery(v).removeClass('d-none');
				}
			});
		}
		checkIfNoArticles();
		checkIfNoDownloads();
		checkIfNoTopics();

		checkCardNumbers(['.featured-card-main', '.topic-areas-main', '.download-card-main']);

	});

	jQuery('.filter-select:not([name="epm_topic"])').on('change', function () {
		jQuery('#topic-form').submit();
	});



	const featuredCards = document.querySelectorAll('.dif-featured-card, .featured-download-card, .topic-areas-card');
	const filterRadiobtns = document.querySelectorAll('.filter-radiobtn-dynamic');
	const filterRadiobtnsArray = Array.from(filterRadiobtns);

	let featuredCardsCategories = [];
	featuredCards.forEach(card => {
		let cardCategories = card.getAttribute('data-categories').replace(/[\[\]']+/g, '');
		cardCategories = cardCategories.split(',');
		cardCategories.forEach(category => {
			featuredCardsCategories.push(category.trim());
		});
		// remove duplicates from the array
		featuredCardsCategories = [...new Set(featuredCardsCategories)];
	});

	console.log(featuredCardsCategories);
	filterRadiobtnsArray.forEach(btn => {
		if (!featuredCardsCategories.includes(btn.textContent.toUpperCase())) {
			btn.parentElement.style.display = 'none';
		}
	});



	jQuery(".event-group-video-play-button").on("click", function () {
		jQuery(".training_events_cards").find(".video-viewer").addClass("open");
	});
	jQuery(".hexagon-play-button").on("click", function () {
		jQuery(".training_events_cards").find(".video-viewer").addClass("open");
	});
	jQuery(".close-button").on("click", function () {
		jQuery(".training_events_cards").find(".video-viewer").removeClass("open");
		// Find the iframe and pause it
		jQuery(".training_events_cards").find(".video-viewer iframe").each(function () {
			jQuery(this).attr("src", jQuery(this).attr("src"));
		}
		);
	});





});







